module.exports = __webpack_public_path__ + "img/icon_map_108_off_010.b636507b.png";